import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { SpacerComponent } from '../../types/landingPageV2'
import Box from '@material-ui/core/Box'
import getColor from '../../utils/colors'
import clsx from 'clsx'
import useHide from '../../hooks/useHide'

export interface SpacerProps {
  item: SpacerComponent
}

const Spacer: React.FC<SpacerProps> = ({ item }) => {
  const classes = useStyles(item)
  const hideClasses = useHide(item.hideOn)
  return <Box className={clsx(classes.box, hideClasses)} />
}

export const useStyles = makeStyles((theme) =>
  createStyles({
    // @ts-ignore
    box: {
      width: '100%',
      maxWidth: '100%',
      // @ts-ignore
      backgroundColor: ({ color }) => getColor(color, theme),
      // @ts-ignore
      height: ({ size }) => {
        switch (size) {
          case 'small':
            return '1rem'
          case 'medium':
            return '2rem'
          case 'large':
            return '3.25rem'
          default:
            return '0'
        }
      },
      [theme.breakpoints.down('sm')]: {
        // @ts-ignore
        height: ({ size }) => {
          switch (size) {
            case 'small':
              return '.5rem'
            case 'medium':
              return '1rem'
            case 'large':
              return '1.625rem'
            default:
              return '0'
          }
        },
      },
    },
  })
)

export default Spacer
